import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0 1rem;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    gap: 1rem;

    h1 {
      font-size: 2.4rem;
      font-weight: 600;
      color: var(--primary);
    }

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 1.5rem;

      h1 {
        font-size: 2rem;
      }
    }

    @media (max-width: 480px) {
      h1 {
        font-size: 1.8rem;
      }
    }
  }
`;

export const AllManageStateContainerPrecookingSetup = styled.div`
  // display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  // gap: 2rem;
  // margin-top: 2rem;
  // width: 100%;

  /* Allow full-width items to span all columns */
  & > div[style*="gridColumn"] {
    grid-column: 1 / -1;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin-top: 1rem;
  }
`;
export const AllManageStateContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  gap: 2rem;
  margin-top: 2rem;
  width: 100%;

  /* Allow full-width items to span all columns */
  & > div[style*="gridColumn"] {
    grid-column: 1 / -1;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin-top: 1rem;
  }
`;

export const Cart = styled.div`
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.1);
  border: 0.1rem solid var(--border);
  transition: all 0.3s ease;
  width: 100%;

  &:hover {
    transform: translateY(-0.2rem);
    box-shadow: 0 0.4rem 2rem rgba(0, 0, 0, 0.15);
  }

  .banner-img-title {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;

    .banner-title {
      h1 {
        font-size: 1.8rem;
        font-weight: 600;
        color: var(--primary);
        margin-bottom: 0.5rem;
      }

      p {
        font-size: 1.4rem;
        color: var(--text-secondary);
        margin: 0;
        word-wrap: break-word;
        line-height: 1.5;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem;

    .banner-img-title {
      .banner-title {
        h1 {
          font-size: 1.6rem;
        }

        p {
          font-size: 1.3rem;
        }
      }
    }
  }

  @media (max-width: 480px) {
    padding: 1rem;

    .banner-img-title {
      .banner-title {
        h1 {
          font-size: 1.4rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }
  }
`;
